import type { IconProps } from './types';
import './icons.css';

export default function Avatar({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 100}
      height={height || 100}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-avatar ${className || ''}`}
    >
      <g clipPath="url(#clip0_220_76673)">
        <rect width="100" height="100" rx="8" fill="#E6EAEC" />
        <g clipPath="url(#clip1_220_76673)">
          <path
            d="M45.4989 15.288C42.6186 16.0081 38.5658 18.4974 35.8296 21.2747C33.7723 23.332 32.6614 25.0601 31.9619 27.2409C31.571 28.4958 31.5093 29.113 31.5298 31.9726C31.5298 33.9271 31.6944 36.2518 31.9002 37.6919L32.2499 40.1195L31.6327 40.8396C30.8304 41.7242 30.7069 42.2797 30.8715 43.8843C31.0567 45.7565 31.7356 47.9784 32.6408 49.7682C33.0934 50.6323 33.4637 51.4552 33.4637 51.5992C33.4637 52.1958 34.9244 56.2075 35.7473 57.8122C37.0845 60.5073 38.5041 62.4617 40.6436 64.6013C43.709 67.6666 46.4041 69.045 49.7163 69.2508C56.4848 69.6828 63.2533 63.3052 66.3598 53.6153C66.7095 52.525 66.9976 51.5169 66.9976 51.3729C66.9976 51.2495 67.3679 50.406 67.8205 49.5213C68.8491 47.5258 69.4663 45.201 69.4663 43.1849C69.4663 41.7242 69.4252 41.6213 68.7668 40.9218L68.0673 40.2018L68.3759 38.4531C68.7874 35.8815 68.9725 29.6273 68.6434 28.2078C68.0673 25.5539 66.1746 23.2086 62.8007 20.925C59.4061 18.662 53.8103 16.2138 50.1483 15.3909C48.1322 14.9588 46.9595 14.9177 45.4989 15.288Z"
            fill="#9EA7AE"
          />
          <path
            d="M38.072 67.4815C37.352 68.2838 33.5254 70.6703 30.7069 72.0898C27.9502 73.4682 26.8392 73.9414 21.7371 75.8958C18.9186 76.9656 17.2934 77.9325 15.4213 79.6812C13.508 81.4711 12.3765 83.0552 11.0598 85.7708C8.73506 90.5849 7.76813 96.7773 8.17959 103.998C8.40589 108.298 9.24938 113.38 9.82542 114.079C10.3603 114.717 16.1619 116.589 20.5439 117.535C29.2257 119.408 38.216 120.23 50.3335 120.23C62.7184 120.23 72.2025 119.325 80.9048 117.35C85.1634 116.383 90.3478 114.676 90.8416 114.079C91.0884 113.791 91.7879 110.602 92.0965 108.401C92.7343 103.916 92.6931 97.4151 91.9936 93.4034C91.0473 87.9104 88.7225 83.014 85.6778 80.0927C83.2296 77.7268 81.8923 76.9656 77.0783 75.1963C71.6059 73.1802 64.1379 69.189 62.5949 67.5021L62.2246 67.07L60.8462 68.2221C53.7074 74.2911 47.1035 74.3323 39.9853 68.3661C38.4835 67.1112 38.4218 67.0906 38.072 67.4815Z"
            fill="#9EA7AE"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_220_76673">
          <rect width="100" height="100" rx="8" fill="white" />
        </clipPath>
        <clipPath id="clip1_220_76673">
          <rect
            width="105.333"
            height="105.333"
            fill="white"
            transform="translate(-2.33325 15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
